module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en.json
// module id = 3z5P
// module chunks = 0